let baseUrl = "";

switch (process.env.NODE_ENV) {
  case "development":
    baseUrl = "/sapi-proxy/"; // 生产环境url (proxied via devServer to avoid CORS)
   // baseUrl = "http://18.223.101.73:8089/"; // development
    //  baseUrl = "http://localhost:8089/"; // local IntelliJ
    break;
  case "cloud": // 注意这里的名字要和步骤二中设置的环境名字对应起来
    baseUrl = "https://sapi.vapevendingsoftware.com/";
    break;
  case "production":
    baseUrl = "https://sapi.vapevendingsoftware.com/";
    break;
}

let config = {
  method: "get",
  // 基础url前缀
  baseUrl: baseUrl,
  // 请求头信息
  header: {
    "Content-Type": "application/json;charset=UTF-8"
  },
  // 参数
  data: {},
  // 设置超时时间 取消设置默认超时时间 默认为浏览器2min
  // timeout: 60000,
  // 携带凭证
  withCredentials: true,
  // 返回数据类型
  responseType: "json",
  // 系统版本 2.0=>2 3.0=>3
  sysversion: "3.0"
};

export default config;
